<template>
    <div class="container">
        <div class="product row py-5">
            <div class="col-md-6">
                <image-slider v-if="viewProduct.product_variant.product.images" :imgs="viewProduct.product_variant.product.images"/>
                <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview-large.jpg`)" class="img-fluid w-100">
            </div>
            <div class="col-md-6">
                <div class="product-info">
                    <div class="product-header">
                        <span class="product-labels">
                            {{ viewProduct.product_variant.name }}
                            <small class="float-right">{{ $t('piece') }}</small>
                        </span>
                        <span class="product-titles">
                            {{ viewProduct.quantity }}x {{ viewProduct.product_name }}
                            <small>
                                {{ viewProduct.product_variant.price_gross | currency }}
                            </small>
                        </span>
                    </div>
                    <div class="product-body" v-if="viewProduct.product_variant.product.description" v-html="viewProduct.product_variant.product.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .product {

        &-header {
            margin-top: 60px;
        }

        &-info {
            padding-left: 20px;

            @media (max-width: 768px) {
                padding-left: 0;
            }
        }

        &-labels,
        &-titles {
            display: block;
            line-height: 1;

            &:after {
                content: '';
                display: table;
                clear: both;
            }
        }

        &-labels {
            margin-bottom: 15px;
            font-size: 1.5rem;
            color: var(--text-secondary-color);
        }

        &-titles {
            position: relative;
            font-size: 3rem;
            padding-right: 150px;
            color: var(--text-color);

            small {
                position: absolute;
                top: 0;
                right: 0;
                font-weight: 500;
            }
        }

        &-body {
            margin-top: 40px;
            margin-bottom: 15px;
            font-size: 1rem;
            color: var(--text-secondary-color);
            line-height: 1.8;
        }

        .btn {
            margin-top: 30px;
        }

        img {
            width: 100%;
            height: auto;
        }
    }

    body.-is-mobile {

        .product {
            padding: 20px 0 70px !important;

            &-header {
                margin-top: 30px;
            }

            &-labels {
                margin-bottom: 3px;
                font-size: 1.125rem;

                small {
                    font-size: .75rem;
                }
            }

            &-titles {
                line-height: 1.5;
                padding-right: 90px;

                &,
                small {
                    font-size: 1.5rem;
                }
            }

            &-body {
                margin-top: 20px;
                margin-bottom: 0;
            }

            p {
                font-size: .87rem;
            }

            .btn {
                position: fixed;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 70px;
                height: 70px;
                margin: 0;
                right: 20px;
                bottom: 45px;
                border-radius: 50%;
                background-color: var(--success-color);
                z-index: 3;

                .material-icon {
                    margin: 0;
                    font-size: 2.1rem !important;
                }
            }
        }
    }
</style>

<script>
  import imageSlider from '../ImageSlider';

  import setStep1ViewProduct from 'src/mixins/setStep1ViewProductComponent';

  export default {
    mixins: [setStep1ViewProduct],
    components: {
      imageSlider,
    },
  };
</script>